<template>
  <v-app id="acp" dark>
    <v-app-bar app dark :color="divisionTheme.theme.backgrounds.header">
      <v-container fluid>
        <v-row>
          <v-col cols="4">
            <img alt="logo" style="height:40px;" :src="divisionTheme.logo" />
          </v-col>

          <v-col cols="4" v-if="!$vuetify.breakpoint.mdAndDown" class="d-flex justify-center">
            <h1 :class="{'sm-header': $vuetify.breakpoint.mdAndDown}">
              Avalanche Apex Connect
            </h1>
          </v-col>

          <v-col cols="4" v-if="!$vuetify.breakpoint.mdAndDown" class="d-flex justify-end">
            <div v-if="isAuthenticated">
              <div v-if="!$vuetify.breakpoint.smAndDown">
                <v-btn text to="/games">Your Games</v-btn>
                <v-btn text to="/friends">Friends</v-btn>
                <v-btn text to="/settings">Settings</v-btn>
              
                <v-menu left bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-menu</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="logout()">
                      <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

            </div>
          </v-col>

          <v-col cols="8" v-else class="d-flex justify-end">
            <div v-if="isAuthenticated">
              <div>
                <v-menu left bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-menu</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-btn text to="/games">Your Games</v-btn>
                    <v-btn text to="/friends">Friends</v-btn>
                    <v-btn text to="/settings">Settings</v-btn>
                    <v-list-item @click="logout()">
                      <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <div id="app" class="app_main" :style="{'background': divisionTheme.theme.backgrounds.body}">
      <v-main>
        <v-container fluid class="py-16" :style="{'color': divisionTheme.theme.light.text}">
          <router-view />
        </v-container>
      </v-main>

      <v-dialog v-model="showPolicyDialog" max-width="800" :fullscreen="$vuetify.breakpoint.mobile">
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="showPolicyDialog = false">close</v-btn>
          </v-card-actions>
          <v-card-text>
            <div v-html="selectedPolicy.text" class="policy"></div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showUpdatePoliciesDialog" max-width="800" :fullscreen="$vuetify.breakpoint.mobile" persistent>
        <v-card>
          <v-card-text>
            <div class="pt-10">
              <h2>Terms of service Update</h2>
              <p>Our Terms of Service have changed. Please read them carefully to continue.</p>

              <div v-if="unapprovedPolicies.length"> 
                <v-checkbox v-for="policy in unapprovedPolicies" :key="policy.identifier" class="mb-0 mt-0" @change="policyCheck(policy, $event)" required>
                  <template v-slot:label>
                    <div>I have read and accept the
                      <a  href="#" @click.stop="showPolicyDialog = true; selectedPolicy = policy">
                      {{policy.identifier}}
                      </a>
                    </div>
                  </template>
                </v-checkbox>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="!allPoliciesAccepted" @click="acceptPolicies(unapprovedPolicies)">Continue</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-footer padless :dark="true" :color="divisionTheme.theme.backgrounds.footer" v-if="acpConfig.show_footer">
        <v-card width="100%" flat tile class="pa-10" :color="divisionTheme.theme.backgrounds.footer">

          <v-card-text class="py-0">
            <v-row>
              <v-col>
                <div class="my-3" style="display:inline-block">
                  <div class="pb-5">
                    <img style="height:75px;" alt="logo" :src="acpConfig.company_logo" />
                  </div>
                  <div>
                  <span> &copy; {{ new Date().getFullYear() }} Avalanche Studios Group</span>
                  </div>
                </div>
              </v-col>
              <v-col class="text-right">  
        
                <v-btn v-for="policy in policies" :key="policy.identifier" text rounded class="my-2" @click="showPolicy(policy)">
                  {{ policy.identifier }}
                </v-btn>

                <br />

                <v-btn text rounded href="https://avalanchestudios.com" target="_new">
                  AVALANCHE STUDIOS GROUP
                </v-btn>
          
                <v-btn text rounded href="https://avalanchestudios.com/divisions/expansive-worlds" target="_new">
                  Expansive Worlds
                </v-btn>

                <v-btn text rounded href="https://avalanchestudios.com/divisions/systemic-reaction" target="_new">
                  Systemic Reaction
                </v-btn>

                <br />

                <v-btn text rounded href="https://avalanchestudios.com/support" target="_new">
                  Support
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-footer>
    </div>
  </v-app>
</template>

<style>
/* avalanche headline */
@font-face {
  font-family: "Avalanche Headline";
  src: url("https://acp-portal-assets.avalanchestudios.com/Fonts/AvalancheHeadline.woff2");
}

/* object sans */
@font-face {
  font-family: "Object Sans";
  src: url("https://acp-portal-assets.avalanchestudios.com/Fonts/ObjectSans-Regular.woff2");
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: "Object Sans";
  src: url("https://acp-portal-assets.avalanchestudios.com/Fonts/ObjectSans-Bold.woff2");
  font-style: normal;
  font-weight: 600;
}

@font-face {
  font-family: "Object Sans";
  src: url("https://acp-portal-assets.avalanchestudios.com/Fonts/ObjectSans-Slanted.woff2");
  font-style: italic;
  font-weight: 400;
}

@font-face {
  font-family: "Object Sans";
  src: url("https://acp-portal-assets.avalanchestudios.com/Fonts/ObjectSans-BoldSlanted.woff2");
  font-style: italic;
  font-weight: 600;
}

.v-card__text, .v-card__title {
  word-break: normal; /* maybe !important  */
}

html,
.v-application {
  font-family: "Object Sans", sans-serif !important;
}

.v-application .headline,
.v-application .title {
  font-family: "Object Sans", sans-serif !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Avalanche Headline";
}

.policy code {
  color: inherit;
  background-color: inherit;
  padding: 0;
}

.app_main {
  background-size: cover !important;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

</style>

<script>
import Vue from "vue";
import store from "./store";
import router from "./router";
import { mapState } from "vuex";
import { auth } from "./store/modules/auth";
import { policies } from "./store/modules/policies";
import { news } from './store/modules/news';

import { themes } from '../src/presets/asg/theme';

if (!store.state.auth) store.registerModule("auth", auth);
if (!store.state.policies) store.registerModule("policies", policies);
if (!store.state.news) store.registerModule("news", news);

Vue.prototype.$http.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.error(error);
    if (error.response && error.response.status == 401) {
      store.dispatch("auth/logout").then(() => {
        setTimeout(() => {
          router.replace("/").catch(() => {});
        }, 100);
      });
    }

    return Promise.reject(error);
  }
);

export default {
  name: "App",
  
  data() {
    return {
      selectedPolicy: {},
      showPolicyDialog: false,
      loginTo: "/login",
      registerTo: "/register",
      showUpdatePoliciesDialog: false,
      acceptedPolicies: {},
    };
  },
  computed: {
    ...mapState("auth", {
      isAuthenticated: (state) => state.isAuthenticated,
      approvedPolicies: (state) => state.approvedPolicies,
    }),
    ...mapState("policies", {
      policies: (state) => state.policies,
      unapprovedPolicies: (state) => state.unapprovedPolicies
    }),
    allPoliciesAccepted() {
      return this.unapprovedPolicies.length > 0 &&
        this.unapprovedPolicies.every(p => this.acceptedPolicies[p.identifier]);
    },
    acpConfig: () => {
      return window.ACP_CONFIG;
    },
    toolbarHeight: () => {
      if (window.ACP_CONFIG.show_header) {
        return 70;
      }
      return 5;
    },
    themeClass: () => {
      let theme = localStorage.getItem('themeName');
      switch(theme) {
        case 'trt':
          return 'trt-theme';
        case 'sr':
          return 'sr-theme';
        case 'ew':
          return 'ew-theme';
        default:
          return 'asg-theme';
      }
    },
    divisionTheme: () => {
      let themeName = sessionStorage.getItem('themeName');
      return themes[themeName];
    }
  },
  watch: {
    isAuthenticated(value) {
      if (value) {
        this.fetchUnapprovedPolicies();
      }
    }
  },
  created() {
    this.fetchPolicies();

    if (this.isAuthenticated) {
      this.fetchUnapprovedPolicies();
    }

    this.$store.dispatch('news/fetchArticles');

    var query = window.location.search;

    if (query != "") {
      this.loginTo = "/login" + query;
      this.registerTo = "/register" + query;
    }

  },
  methods: {    
    fetchPolicies() {
      this.$store.dispatch("policies/getPolicies");
    },
    fetchUnapprovedPolicies() {
      this.$store.dispatch("policies/getUnnaprovedPolicies", this.approvedPolicies).then(resp => {
        this.showUpdatePoliciesDialog = resp.length > 0;
      });
    },
    showPolicy(policy) {
      this.selectedPolicy = policy;
      this.showPolicyDialog = true;
    },
    policyCheck(pol, e) {
      this.$set(this.acceptedPolicies, pol.identifier, !!e);
    },
    acceptPolicies(policies) {
      const token = localStorage.getItem('vue-authenticate.vueauth_token');
      Promise.all(
        policies.map(policy => this.$store.dispatch("policies/approvePolicy", { policy: policy, token: token }))
      ).then(() => {
        // The refetch compares against approvedPolicies, so record the new approvals first
        // or it recomputes the same unapproved list and reopens the dialog.
        const accepted = policies.map(p => ({
          policy_identifier: p.identifier,
          policy_version_id: p.version
        }));
        const merged = this.approvedPolicies
          .filter(a => !policies.some(p => p.identifier === a.policy_identifier))
          .concat(accepted);

        this.$store.commit("auth/setApprovedPolicies", merged);
        this.acceptedPolicies = {};
        this.fetchUnapprovedPolicies();
      }).catch(err => {
        console.error("Failed to accept policies", err);
      });
    },
    settings() {
      this.$router.push("settings").catch(() => {});
    },
    friends() {
      this.$router.push("friends").catch(() => {});    
    },
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        setTimeout(() => {
          this.$router.replace("/").catch(() => {});
        }, 100);
      });
    },
  },
};
</script>


